export default __webpack_public_path__ + "static/media/talto_calendar_2022.4df2622f.jpg";